import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=53512509&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53512509"]])

export default __exports__